import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { useState } from 'react';
import useBlockClientCard from '../../hooks/useBlockClientCard';
import { useQueryClient } from '@tanstack/react-query';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';

interface BlockPersonalCardProps {
  userId?: string
  cardId?: string
}

const BlockPersonalCard = ({ userId, cardId }: BlockPersonalCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient();

  const {
    mutate: blockClientUserCard,
    isPending: isBlockClientUserCardPending,
  } = useBlockClientCard({
    cardId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientUser', userId] });
      setIsOpen(false);
    },
    onError: (error) => {
      setMessages(error.response?.data.errors.base || ['Occorreu um erro ao bloquear cartão.']);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button type="button" variant="yellow-black" operationKlassToCheckPermission='Client::Cards::Block'>
            Bloquear cartão
          </Button>
        )}
        title="Você tem certeza?"
        subtitle="Caso o cartão do usuário seja bloqueado, nenhuma transação poderá ser feita pelo usuário quando utilizando este cartao."
        titleClass="text-xl"
        subtitleClassName="mt-2 !text-[16px] text-white-300"
        showClose={false}
        useCancellableFooter
        onConfirm={() => blockClientUserCard()}
        confirmButtonIsLoading={isBlockClientUserCardPending}
        disabled={isBlockClientUserCardPending}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default BlockPersonalCard;
